var map = {
	"./en/translation": 87551,
	"./en/translation.json": 87551,
	"./ja/translation": 82820,
	"./ja/translation.json": 82820,
	"./ko/translation": 644,
	"./ko/translation.json": 644,
	"./locale-keys": 30980,
	"./locale-keys.json": 30980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92947;